import React, { useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper'
import { CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite'
import { getBankListApi } from '_services'
import toast from 'react-hot-toast'

const formObj = {
    bank: null,
}

// Validation schema for bank selection
const bankValidationSchema = {
    bank: {
        required: true,
        message: "Please select a bank"
    }
}

const BankSelectModal = (props) => {
    const { setBankDetails, bankDetails, onSubmit, isLoadding } = props;

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchBank = async (search, page, limit) => {
        const res = await getBankListApi({
            company_id: StorageService.getCompanyId(),
            offset: page,
            limit,
            search,
        });
        
        if (res?.responseCode === 200) {
            setLoading(false);
            const list = await res?.data?.list?.map((i) => ({
                ...i,
                name: `${i?.name } | ${i?.number}`,
                label: i?.name,
                value: i?._id
            }))

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            setLoading(false);
            toast.error(res?.responseMessage);
        }
    };

    const validateForm = (data) => {
        const errors = {};
        
        // Check if bank is selected
        if (!data.bank || !data.bank.value) {
            errors.bank = bankValidationSchema.bank.message;
        }
        
        return errors;
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...bankDetails, [name]: item };
        setBankDetails(stateObj);

        // Clear specific field error when user selects a value
        if (formError[name] && item) {
            const updatedErrors = { ...formError };
            delete updatedErrors[name];
            setFormError(updatedErrors);
        }
    };

    const handleSubmit = () => {
        // Validate form before submission
        const errors = validateForm(bankDetails);

        console.log("errors",errors)
        
        if (Object.keys(errors).length > 0) {
            setFormError(errors)
            return;
        }

        // Clear errors and proceed with submission
        setFormError({});
        if (onSubmit) {
            onSubmit();
        }
    };

    // Override the modal props to use our custom submit handler
    const modalProps = {
        ...props,
        onSubmit: handleSubmit,
        isLoadding: isLoadding
    };

    return (
        <div>
            <CommonModal {...modalProps}>
                <div className='addLr_body'>
                    <SingleSelectDropdownInfinite
                        label="Select Bank"
                        fetchData={fetchBank}
                        selectedItem={bankDetails?.bank}
                        onChange={(data) => onhandleSelect(data, "bank")}
                        error={!!formError.bank}
                        errorMessage={formError.bank}
                        pageSize={20}
                        placeholder="Choose a bank..."
                        required={true}
                    />
                    
                    {/* Optional: Show validation message */}
                    
                </div>
            </CommonModal>
        </div>
    )
}

export default BankSelectModal